import { withChartLayout } from 'components/common';
import HeightWeight from 'components/features/chart/vital-signs/height-weight/HeightWeight';

const HeightWeightPage = withChartLayout('Height - Weight')(HeightWeight);
export default HeightWeightPage;
